import { randProductAdjective, randUuid } from '@ngneat/falso';

import type { ManufactureDetail } from 'src/gql/__generated__/bom-bff';

export const mockManufactureDetail = (
    overwrite?: Partial<ManufactureDetail>
): ManufactureDetail => ({
    manufactureDetailPublicId: randUuid(),
    manufactureDetailName: randProductAdjective(),
    isDeleted: false,
    manufacture: null,
    ...overwrite,
});
